import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 27"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="97.304%" id="jglkvcodnb">
        <stop stopColor="#FDCC51" offset="0%" />
        <stop stopColor="#F79E13" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="rxdjbm27da">
        <stop stopColor="#FFDD84" offset="0%" />
        <stop stopColor="#F6BB63" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.078%"
        y1="23.94%"
        x2="91.089%"
        y2="78.069%"
        id="vwus1sr0hc"
      >
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.5.821c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.023 7.297c0 2.468-1.54 5.495-3.44 8.161-2.494 3.499-5.655 6.52-6.88 6.52-1.225 0-4.386-3.021-6.88-6.52-1.9-2.666-3.44-5.693-3.44-8.161 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.5.82Z"
        stroke="url(#rxdjbm27da)"
        fill="url(#jglkvcodnb)"
      />
      <g fillRule="nonzero">
        <path
          d="M9 10.58 11.433 9h1.133L15 10.58V15h-1.768v-1.59c0-.661-.554-1.202-1.232-1.202-.678 0-1.232.54-1.232 1.202V15H9v-4.42Z"
          fill="#FFF"
        />
        <path
          d="M4.231 1.237h1.183V0H6.56v1.237h1.183v1.2H6.56v1.237H5.414V2.437H4.23v-1.2Zm7.275 6.095c.07.038.14.078.14.172v2.325c0 .093-.063.171-.14.171h-1.86V6.304l1.86 1.028ZM.14 7.342C.07 7.38 0 7.42 0 7.513v2.325c0 .094.063.171.14.171H2V6.312L.14 7.342Z"
          fill="url(#vwus1sr0hc)"
          transform="translate(6.013 5)"
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent
